module.exports = __webpack_public_path__ + "img/asideicon.2e49ea54.png";